<template>
  <div class="owner_menu">
    <el-menu
      @open="handleOpen"
      @close="handleClose"
      @select="handleSelect"
      :default-active="this.$route.path"
      router
      class="menu"
    >
      <el-submenu index="/MyOwner">
        <template slot="title">
          <span slot="title">金主</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/MyOwner">
            <div class="line"></div>
            <i class="iconfont icon-kehu"></i>
            <span slot="title">我的金主</span>
          </el-menu-item>
          <el-menu-item index="/TaskCenter">
            <div class="line"></div>
            <i class="iconfont icon-wp-sj"></i>
            <span slot="title">任务中心</span>
          </el-menu-item>
          <el-menu-item index="/OwnerBookInfo">
            <div class="line"></div>
            <i class="iconfont icon-wp-sj"></i>
            <span slot="title">金主书籍信息</span>
          </el-menu-item>
          <el-menu-item index="/OwnerHighSeas">
            <div class="line"></div>
            <i class="iconfont icon-gonghaiguanli"></i>
            <span slot="title">金主公海信息</span>
          </el-menu-item>
          <el-menu-item index="/DownloadFileRecord">
            <div class="line"></div>
            <i class="iconfont icon-jilu"></i>
            <span slot="title">文件下载记录</span>
          </el-menu-item>
          <el-menu-item index="/ownerCheaterPool">
            <div class="line"></div>
            <i class="iconfont icon-zongcejieguochakan"></i>
            <span slot="title">骗子库</span>
          </el-menu-item>
          <el-menu-item index="/ownerFeeExpenditure">
            <div class="line"></div>
            <i class="iconfont icon-chuyuanjiesuan"></i>
            <span slot="title">其余费用支出</span>
          </el-menu-item>
          <el-menu-item index="/ownerFeeIncome">
            <div class="line"></div>
            <i class="iconfont icon-chuyuanjiesuan"></i>
            <span slot="title">其余费用收入</span>
          </el-menu-item>
          <el-menu-item index="/DownLoadManuscript">
            <div class="line"></div>
            <i class="iconfont icon-xiazai"></i>
            <span slot="title">下载周稿</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="/">
        <template slot="title">
          <!-- <i class="el-icon-caret-bottom"></i> -->
          <span slot="title">数据中心</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/OwnerExamine">
            <div class="line"></div>
            <i class="iconfont icon-kaohe"></i>
            <span slot="title">我的考核</span>
          </el-menu-item>
          <el-menu-item index="/OwnerData">
            <div class="line"></div>
            <i class="iconfont icon-data1"></i>
            <span slot="title">我的数据</span>
          </el-menu-item>
          <el-menu-item index="/OwnerDayRecord">
            <div class="line"></div>
            <i class="iconfont icon-register"></i>
            <span slot="title">金主日结登记</span>
          </el-menu-item>
          <el-menu-item index="/OwnerDaySheet">
            <div class="line"></div>
            <i class="iconfont icon-shuji"></i>
            <span slot="title">金主日结表</span>
          </el-menu-item>
          <el-menu-item index="/OwnerWeekRecord">
            <div class="line"></div>
            <i class="iconfont icon-register"></i>
            <span slot="title">金主周结登记</span>
          </el-menu-item>
          <el-menu-item index="/OwnerWeekSheet">
            <div class="line"></div>
            <i class="iconfont icon-shuji"></i>
            <span slot="title">金主周结表</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    // 菜单栏的点击
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 子菜单栏的点击
    handleSelect(key, keyPath) {
      // console.log("子菜单")
      // console.log(key, keyPath);
    },
    // 菜单栏的关闭
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    }
  }
};
</script>
<style scoped>
.owner_menu {
  width: 200px;
  height: 92.5vh;
  background-color: #fff;
}

.el-menu {
  border: none;
}
.menu i {
  margin-right: 5px;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
  padding: 5px;
}
.owner_menu .iconfont {
  font-size: 20px;
}
.el-submenu__icon-arrow {
  left: 15px;
  font-size: 20px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.el-icon-arrow-down:before {
  content: "\e790";
}
.el-menu-item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.el-submenu__title {
  padding-left: 40px !important;
}
.el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  transform: rotateZ(-90deg) translateX(80px) translateY(-70px);
  margin-top: -2px;
}
.el-menu-item:focus .line {
  display: block;
}
.line {
  width: 5px;
  height: 50px;
  background: #157df8;
  margin-left: -40px;
  margin-right: 35px;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Owner.vue